import { Strings } from "src/constants";
import { AnalyticBody } from "./analyticBody";

export class PCRAnalyticBody extends AnalyticBody {
    title: string = Strings.ANALYSIS_PCR_COMPE
}